export const ECRTransactionTypes = {
  RealTimeEligibilityCheck: 'Real-Time Eligibility Check',
  Claim: 'Claim',
  Remittance: 'Remittance',
  BatchEligibilityCheck: 'Batch Eligibility Check',
  ClaimStatus: 'ClaimStatus'
}

export const ECRTransactionResultTypes = {
  Successful: 'Successful',
  FailedatPayer: 'Failed at Payer',
  FailedatClearingHouse: 'Failed at Clearing House',
  FailedatCradle: 'Failed at Cradle',
  Pending: 'Pending',
  Sending: 'Sending',
  Sent: 'Sent',
  New: 'New',
  Test: 'Test',
  Waiting: 'Waiting',
  Unknown: 'Unknown'
}
